export default __webpack_public_path__ + "static/media/non-household-2.1730df47.jpg";